import React from "react";

const LightbulbSvg = () => (
  <svg
    viewBox="0 0 95 103"
    css={`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
  >
    <g clipPath="url(#prefix__clip0)" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M35.212 79.14c-12.929-4.895-22.119-17.391-22.119-32.034 0-18.918 15.333-34.248 34.248-34.248s34.248 15.33 34.248 34.248c0 14.295-8.758 26.542-21.202 31.672.187-.875.285-1.782.285-2.712H34.844c0 1.06.127 2.089.368 3.074zm-3.384-24.874c1.759 10.078 10.548 17.738 21.131 17.738 11.85 0 21.456-9.604 21.456-21.452 0-11.752-9.443-21.293-21.152-21.455-3.091-4.14-8.028-6.819-13.591-6.819-9.364 0-16.954 7.591-16.954 16.957 0 6.531 3.695 12.2 9.11 15.031z"
        fill="#FAD532"
      />
      <path
        d="M72.151 87.398l-5.287-8.545a37.73 37.73 0 0 0 3.621-2.548l6.258 7.862a47.64 47.64 0 0 1-4.592 3.231zm-51.708-1.21a47.259 47.259 0 0 1-4.434-3.449l6.629-7.551a37.485 37.485 0 0 0 3.492 2.716l-5.687 8.284zm65.036-11.109l-8.109-5.937a37.385 37.385 0 0 0 2.4-3.717l8.753 4.933a47.809 47.809 0 0 1-3.044 4.721zM7.722 73.252A47.684 47.684 0 0 1 4.9 68.395l8.975-4.524a37.588 37.588 0 0 0 2.223 3.829l-8.376 5.552zm85.47-14.616l-9.749-2.434a38.03 38.03 0 0 0 .819-4.354l9.967 1.274a47.689 47.689 0 0 1-1.037 5.514zM.78 56.478A46.913 46.913 0 0 1 0 50.911l10.017-.795a37.1 37.1 0 0 0 .613 4.375L.78 56.478zm83.431-14.572a36.987 36.987 0 0 0-.868-4.33l9.715-2.563c.478 1.807.85 3.662 1.106 5.511l-9.953 1.382zm-73.668-1.723L.666 38.334a47.736 47.736 0 0 1 1.356-5.447l9.59 3.002a37.674 37.674 0 0 0-1.069 4.294zm69.006-11.784a37.591 37.591 0 0 0-2.442-3.692l8.04-6.027a47.465 47.465 0 0 1 3.096 4.68l-8.694 5.039zM15.82 26.904l-8.449-5.441a47.628 47.628 0 0 1 3.319-4.535l7.743 6.405a37.272 37.272 0 0 0-2.613 3.571zm54.326-9.288A37.39 37.39 0 0 0 66.5 15.11l5.188-8.606a47.373 47.373 0 0 1 4.631 3.183l-6.173 7.929zm-44.418-1.038l-5.792-8.211a47.686 47.686 0 0 1 4.772-2.96l4.779 8.839a37.799 37.799 0 0 0-3.759 2.332zm31.659-5.413a37.293 37.293 0 0 0-4.318-.944L54.627.295c1.856.292 3.703.695 5.49 1.199l-2.73 9.671zm-18.616-.44L36.494.937a47.725 47.725 0 0 1 5.537-.943l1.102 9.987c-1.471.163-2.94.413-4.362.744z"
        fill="#D73D6F"
      />
      <path
        d="M58.224 83.632H37.291a12.86 12.86 0 0 1-2.079-4.492 34.17 34.17 0 0 0 12.129 2.209c4.619 0 9.025-.914 13.046-2.571a12.858 12.858 0 0 1-2.163 4.854z"
        fill="#FAD532"
      />
      <path
        d="M47.341 81.349a34.17 34.17 0 0 1-12.129-2.209 12.917 12.917 0 0 1-.368-3.074h25.828c0 .93-.098 1.837-.285 2.712a34.164 34.164 0 0 1-13.046 2.571z"
        fill="#F2B229"
      />
      <path
        d="M58.943 90.09h-22.37a12.849 12.849 0 0 1-1.729-6.458h2.447a12.9 12.9 0 0 0 10.467 5.348c4.306 0 8.12-2.108 10.466-5.348h2.448c0 2.352-.63 4.558-1.729 6.458z"
        fill="#FAD532"
      />
      <path
        d="M47.758 88.98a12.9 12.9 0 0 1-10.467-5.348h20.933a12.896 12.896 0 0 1-10.466 5.348z"
        fill="#F2B229"
      />
      <path
        d="M47.758 103c-7.132 0-12.914-5.78-12.914-12.91h1.729a12.91 12.91 0 0 0 11.185 6.454c4.778 0 8.951-2.596 11.185-6.454h1.729c0 7.13-5.782 12.91-12.914 12.91z"
        fill="#FAD532"
      />
      <path
        d="M47.758 96.544a12.91 12.91 0 0 1-11.185-6.454h22.37a12.912 12.912 0 0 1-11.185 6.454zM31.828 54.266c-5.415-2.831-9.11-8.5-9.11-15.031 0-9.366 7.59-16.957 16.954-16.957 5.563 0 10.5 2.679 13.591 6.819-.102-.002-.203-.002-.304-.002-11.85 0-21.451 9.604-21.451 21.457 0 1.267.109 2.507.32 3.714zM52.959 72.004c-10.583 0-19.372-7.66-21.131-17.738a16.886 16.886 0 0 0 7.844 1.919c9.364 0 16.952-7.59 16.952-16.95 0-3.801-1.25-7.311-3.361-10.138 11.709.162 21.152 9.703 21.152 21.455 0 11.848-9.606 21.452-21.456 21.452z"
        fill="#F2B229"
      />
      <path
        d="M39.672 56.185c-2.83 0-5.498-.693-7.844-1.919a21.546 21.546 0 0 1-.32-3.714c0-11.853 9.601-21.457 21.451-21.457.101 0 .202 0 .304.002a16.887 16.887 0 0 1 3.361 10.138c0 9.36-7.588 16.95-16.952 16.95z"
        fill="#EC952D"
      />
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path fill="#fff" d="M0 0h95v103H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default LightbulbSvg;
